<template>
  <section v-if="banners?.length">
    <slider 
      id="carousel"
      class="carousel"
      animation="fade"
      :speed="500"                                                                                                                                        
      :interval="5000"                                                                                                                                    
      :control-btn="false"
      width="100%"
      height="180px"
    >
      <slider-item
        v-for="(banner, index) in banners"
        :key="index"
      >
        <a @click="openExternalUrl(banner.externalUrl)">
          <img :src="banner.imageUrl" />
        </a>       
      </slider-item>
    </slider>

  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';
import {
  fetchBanners,
} from "@/apis/fetchData";

export default {
  name: 'BannerWrapper',
  // props: {
  //   shopId: String
  // },
  components: {
  },
  data() {
    return {
      banners: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      shopId: "getShopId",
    })
  },
  mounted() {
    this.getBanners();
  },
  methods: {
    async getBanners() {
      this.loading = true;
      try {
        let bannerResponse = await fetchBanners(this.shopId);
        this.banners = bannerResponse.data?.data || [];
      } catch (error) {
        console.log('Fail to get banners.', error);
      }
      // this.banners = [
      //   {
      //     "imageUrl": "https://storage.googleapis.com/gofoodie_assets/demo/milkhouses_banner1.png",
      //     "description": "2024 夏季優惠活動 - 全館商品 8 折起，滿千送百",
      //     "externalUrl": "https://example.com/promotions/summer-sale"
      //   },
      //   {
      //     "imageUrl": "https://storage.googleapis.com/gofoodie_assets/demo/milkhouses_banner2.png",
      //     "description": "2024 夏季優惠活動 - 全館商品 8 折起，滿千送百",
      //     "externalUrl": "https://example.com/promotions/summer-sale"
      //   }
      // ];
      this.loading = false;
    },
    openExternalUrl(externalUrl){
      if (externalUrl) {                                                                                                                                      
        window.open(externalUrl, "_blank");                                                                                                                   
      } 
    }
  }
};
</script>

<style scoped>
#carousel .slider-indicators {
  bottom: 5px;
}

#carousel .slider-indicator-icon {
  margin: 0 5px;
  border: 1px solid white;
  background-color: white;
  opacity: 1;
  box-shadow: 0px 5px 10px rgba(55, 84, 170, 0.2);
}

#carousel .slider-indicator-active {
  background-color: var(--k1);
}

#carousel {
  border-radius: 10px;
  z-index: 3;
}

#carousel img {
  width: 100%;
  /* aspect-ratio: 16 / 9;*/
  border-radius: 10px;
  object-fit: contain; /* 防止裁切 */
}

</style>